import AcessoNegado from '@/components/AcessoNegado/acessoNegado.es-co.i18n.json'
import ChatPoliticas from '@/components/ChatPoliticas/chatPoliticas.es-co.i18n.json'
import ConexoesMcp from '@/typescript/modulos/governanca/ConexoesMcp/conexoesMcp.es-co.i18n.json'
import AssistentePontotel from '@/typescript/modulos/governanca/AssistentePontotel/assistentePontotel.es-co.i18n.json'
import AcompanhamentoTempoReal from '@/components/AcompanhamentoTempoReal/acompanhamentoTempoReal.es-co.i18n.json'
import FarolDoDP from '@/components/FarolDoDP/farol-do-dp.es-co.i18n.json'
import Auditoria from '@/components/Auditor/auditoria.es-co.i18n.json'
import Faturas from '@/typescript/modulos/tiosam/faturas/faturas.es-co.i18n.json'
import Compartilhados from '@/common/compartilhados.es-co.i18n.json'
import Bora from '@/common/Bora/bora.es-co.i18n.json'
import Biometria from '@/components/FaceBiometric/facebiometric.es-co.i18n.json'
import BiometriaCadastro from '@/typescript/modulos/estrutura-de-pontos-da-empresa/biometria/apresentacao/biometria.es-co.i18n.json'
import Coletor from '@/components/Coletores/coletor.es-co.i18n.json'
import CustomizacoesDeCalculo from '@/components/CustomizacoesDeCalculo/customizacao.es-co.i18n.json'
import Compman from '@/components/CompMan/compman.es-co.i18n.json'
import Dashboards from '@/components/DashBoards/dashboards.es-co.i18n.json'
import Dispositivos from '@/components/Devices/dispositivos.es-co.i18n.json'
import Empregado from '@/components/Employee/employee.es-co.i18n.json'
import Empregador from '@/components/Employer/employer.es-co.i18n.json'
import FeriasEAfastamentos from '@/components/FeriasEAfastamentos/feriasEAfastamento.es-co.i18n.json'
import LocalDeTrabalho from '@/components/Company/local.es-co.i18n.json'
import RegraAprovacao from 'src/components/ApprovalsRules/regraAprovacao.es-co.i18n.json'
import Solicitacao from '@/components/Approvals/i18n/solicitacao.es-co.i18n.json'
import Comuns from '@/typescript/servicos/i18n/locales/comuns.es-co.i18n.json'
import Home from '@/components/Home/home.es-co.i18n.json'
import MainHeader from '@/components/MainHeader/mainHeader.es-co.i18n.json'
import MenuLateral from '@/common/MenuLateral/menuLateral.es-co.i18n.json'
import ControleDeEstacoes from '@/components/ControleDeEstacoes/controleDeEstacoes.es-co.i18n.json'
import Cognito from '@/components/Cognito/cognito.es-co.i18n.json'
import CentralAtendimento from '@/components/CentralAtendimento/centralAtendimento.es-co.i18n.json'
import Groups from '@/components/Groups/groups.es-co.i18n.json'
import Holiday from '@/components/Holiday/holiday.es-co.i18n.json'
import Journey from '@/components/Journey/journey.es-co.i18n.json'
import Locker from '@/components/Locker/locker.es-co.i18n.json'
import LogDeOperacoes from '@/components/LogDeOperacoes/logDeOperacoes.es-co.i18n.json'
import HourBankRules from '@/components/HourBankRules/hourBankRules.es-co.i18n.json'
import FileManagement from '@/components/FileManagement/fileManagement.es-co.i18n.json'
import LockerRules from '@/components/LockerRules/lockerRules.es-co.i18n.json'
import MassChanges from '@/components/MassChanges/massChanges.es-co.i18n.json'
import PainelDePontos from '@/components/PainelDePontos/paineldepontos.es-co.i18n.json'
import Permissions from '@/components/Permissions/permissions.es-co.i18n.json'
import Reason from '@/components/Reason/reason.es-co.i18n.json'
import Reports from '@/components/Reports/reports.es-co.i18n.json'
import Routine from '@/components/Routine/routine.es-co.i18n.json'
import Sheets from '@/components/Sheets/sheets.es-co.i18n.json'
import User from '@/components/User/user.es-co.i18n.json'
import Whb from '@/components/Whb/whb.es-co.i18n.json'
import WorkSchedule from '@/components/WorkSchedule/workSchedule.es-co.i18n.json'
import router from '@/router/router.es-co.i18n.json'
import store from '@/store/store.es-co.i18n.json'
import tipos from '@/tipos/tipos.es-co.i18n.json'
import typescript from '@/typescript/typescript.es-co.i18n.json'
import ModuloSolicitacoes from '@/typescript/modulos/governanca/solicitacoes/solicitacoes.es-co.i18n.json'
import ModuloFolha from '@/typescript/modulos/estrutura-de-pontos-da-empresa/Folha/folha.es-co.i18n.json'
import PainelSolicitacoesDeHorasExtras from '@/typescript/modulos/acompanhamento/PainelSolicitacoesDeHorasExtras/painelSolicitacoesDeHorasExtras.es-co.i18n.json'
import Utils from '@/utils/utils.es-co.i18n.json'
import ModuloGerenciamentoDeFerias from '@/typescript/modulos/calendario-de-trabalho/GerenciamentoDeFerias/gerenciamentoDeFeria.es-co.i18n.json'
import CalendarioAloque from '@/typescript/modulos/calendario-de-trabalho/CalendarioAloque/calendarioAloque.es-co.i18n.json'
import ModuloRegrasDeFerias from '@/typescript/modulos/calendario-de-trabalho/RegrasDeFerias/i18n/regrasDeFerias.es-co.i18n.json'
import LayoutE02 from '@/typescript/modulos/calculos-do-sistema/e02/layoutE02.es-co.i18n.json'
import ParametrizadorE02 from '@/components/ParametrizadorE02/parametrizadorE02.es-co.i18n.json'
import CatalogoLocalDeTrabalho from '@next/modulos/estrutura-de-ponto-da-empresa/local-de-trabalho/catalogo/catalogo-local-de-trabalho.es-co.i18n.json'
import CatalogoRegraDeCalculo from '@next/modulos/folha-de-ponto/regra-de-calculo/catalogo/catalogo-regra-de-calculo.es-co.i18n.json'
import CatalogoEmpregador from '@next/modulos/estrutura-de-ponto-da-empresa/empregador/catalogo/catalogo-empregador.es-co.i18n.json'
import CatalogoEmpregado from '@next/modulos/estrutura-de-ponto-da-empresa/empregado/catalogo/catalogo-empregado.es-co.i18n.json'
import CatalogoMotivoPadrao from '@next/modulos/estrutura-de-ponto-da-empresa/motivo-padrao/catalogo/catalogo-motivo-padrao.es-co.i18n.json'
import CatalogoGrupoDeLocaisDeTrabalho from '@next/modulos/governanca/grupo-de-locais-de-trabalho/catalogo/catalogo-grupo-de-locais-de-trabalho.es-co.i18n.json'
import CatalogoPerfilDePermissao from '@next/modulos/governanca/perfil-de-permissao/catalogo/catalogo-perfil-de-permissao.es-co.i18n.json'
import CatalogoUsuario from '@next/modulos/governanca/usuario/catalogo/catalogo-usuario.es-co.i18n.json'

const mensagens: Record<string, any> = {
  ...ParametrizadorE02,
  words: {
    user: 'usuario | usuarios',
    employee: 'empleado | empleados',
    company: 'lugar de trabajo | lugares de trabajo',
    companyShortName: 'lugar | lugares',
    employer: 'empleador | empleadores',
    supervisor: 'responsable | responsables',
    routine: 'horario | horarios',
    journey: 'jornada | jornadas',
    customRules: 'regla de cálculo | reglas de cálculo',
    locker: 'bloqueo | bloqueos',
    group: 'grupo | grupos',
    all: 'aplicar a todos'
  },
  acessoNegado: AcessoNegado,
  acompanhamentoTempoReal: AcompanhamentoTempoReal,
  farolDoDP: FarolDoDP,
  auditoria: Auditoria,
  tiosam: { faturas: Faturas },
  biometria: { ...Biometria, ...BiometriaCadastro },
  coletor: Coletor,
  customizacoesDeCalculo: CustomizacoesDeCalculo,
  compartilhados: Compartilhados,
  bora: Bora,
  compman: Compman,
  dashboards: Dashboards,
  dispositivos: Dispositivos,
  empregado: Empregado,
  empregador: Empregador,
  feriasEAfastamento: FeriasEAfastamentos,
  local: LocalDeTrabalho,
  regraAprovacao: RegraAprovacao,
  solicitacao: Solicitacao,
  comuns: Comuns,
  home: Home,
  mainHeader: MainHeader,
  MenuLateral: MenuLateral,
  controleDeEstacoes: ControleDeEstacoes,
  cognito: Cognito,
  centralAtendimento: CentralAtendimento,
  groups: Groups,
  holiday: Holiday,
  journey: Journey,
  locker: Locker,
  logDeOperacoes: LogDeOperacoes,
  hourBankRules: HourBankRules,
  fileManagement: FileManagement,
  lockerRules: LockerRules,
  massChanges: MassChanges,
  paineldepontos: PainelDePontos,
  permissions: Permissions,
  reason: Reason,
  reports: Reports,
  routine: Routine,
  sheets: Sheets,
  user: User,
  whb: Whb,
  workSchedule: WorkSchedule,
  router: router,
  store: store,
  tipos: tipos,
  typescript: typescript,
  solicitacoes: ModuloSolicitacoes,
  folha: ModuloFolha,
  painelSolicitacoesDeHorasExtras: PainelSolicitacoesDeHorasExtras,
  utils: Utils,
  gerenciamentoDeFerias: ModuloGerenciamentoDeFerias,
  calendarioAloque: CalendarioAloque,
  regrasDeFerias: ModuloRegrasDeFerias,
  layoutE02: LayoutE02,
  chatPoliticas: ChatPoliticas,
  conexoesMcp: ConexoesMcp,
  assistentePontotel: AssistentePontotel,
  srcNext: {
    folhaDePonto: {
      catalogoRegraDeCalculo: CatalogoRegraDeCalculo,
    },
    governanca: {
      catalogoGrupoDeLocaisDeTrabalho: CatalogoGrupoDeLocaisDeTrabalho,
      catalogoPerfilDePermissao: CatalogoPerfilDePermissao,
      catalogoUsuario: CatalogoUsuario
    },
    estruturaDePontoDaEmpresa: {
      catalogoLocalDeTrabalho: CatalogoLocalDeTrabalho,
      catalogoEmpregador: CatalogoEmpregador,
      catalogoEmpregado: CatalogoEmpregado,
      catalogoMotivoPadrao: CatalogoMotivoPadrao
    }
  }
}

export default mensagens
